import {css} from 'lit'; export default css`:host a{color:var(--goto-type-color-inverted)!important}`;
    